

import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { applySeo, breadcrumbSchema, faqSchema, organizationSchema, serviceSchema, websiteSchema } from '@/utils/seo'
// import { nextTick } from 'vue';

const routes = [
    {
        path: '/',
        redirect: '/p_index'
    },
    {
        path: '/p_index',
        name: 'p_index',
        component: () => import('@/views/pc/index'),
        meta: {
            title: '绿蜜蜂旧衣服回收 - 免费上门环保回收平台',
            description: '绿蜜蜂支持旧衣、旧书、家电、电子杂物、手机数码、家具清运等多品类回收，顺丰免费上门取件，最快2小时上门，全程免费。',
            keywords: '绿蜜蜂,旧衣服回收,旧书回收,家电回收,电子杂物回收,手机回收,家具清运,顺丰免费上门取件',
            canonicalPath: '/',
            schemas: [organizationSchema(), websiteSchema(), serviceSchema(), faqSchema()]
        }
    },
    {
        path: '/p_retrieve',
        name: 'p_retrieve',
        component: () => import('@/views/pc/retrieve'),
        meta: {
            title: '预约回收 - 绿蜜蜂旧衣服免费上门回收',
            description: '预约绿蜜蜂旧衣、旧书、家电、电子杂物、手机数码、家具清运等多品类回收，顺丰免费上门取件，最快2小时上门，全程免费。',
            keywords: '预约回收,旧衣回收,旧书回收,家电回收,电子杂物回收,手机回收,家具清运',
            canonicalPath: '/p_retrieve',
            schemas: [serviceSchema(), faqSchema(), breadcrumbSchema([
                { name: '首页', path: '/' },
                { name: '预约回收', path: '/p_retrieve' }
            ])]
        }
    },
    {
        path: '/p_new',
        name: 'p_new',
        component: () => import('@/views/pc/new'),
        meta: {
            title: '平台资讯 - 绿蜜蜂环保回收动态',
            description: '绿蜜蜂平台资讯分享旧衣、旧书、家电、电子杂物、手机数码、家具清运等环保回收行业动态。',
            keywords: '绿蜜蜂资讯,旧衣回收资讯,旧书回收,家电回收,手机回收,家具清运,环保回收新闻',
            canonicalPath: '/p_new',
            schemas: [organizationSchema(), breadcrumbSchema([
                { name: '首页', path: '/' },
                { name: '平台资讯', path: '/p_new' }
            ])]
        }
    },
    {
        path: '/p_newDetail',
        name: 'p_newDetail',
        component: () => import('@/views/pc/newDetail'),
        meta: {
            title: '资讯详情 - 绿蜜蜂平台资讯',
            description: '查看绿蜜蜂平台资讯详情，了解旧衣回收、顺丰免费上门取件、旧衣服换现金礼品、爱心公益与循环经济内容。',
            keywords: '绿蜜蜂资讯详情,旧衣回收文章,旧衣服换现金,旧衣服换礼品,爱心公益',
            canonicalPath: '/p_newDetail',
            schemas: [breadcrumbSchema([
                { name: '首页', path: '/' },
                { name: '平台资讯', path: '/p_new' },
                { name: '资讯详情', path: '/p_newDetail' }
            ])]
        }
    },
    {
        path: '/p_aboutUs',
        name: 'p_aboutUs',
        component: () => import('@/views/pc/aboutUs'),
        meta: {
            title: '关于我们 - 绿蜜蜂旧衣服回收',
            description: '了解绿蜜蜂旧衣服回收平台、企业资质、环保回收服务和联系方式。客服电话 400-887-6885，合作邮箱 lvmifo@163.com。',
            keywords: '关于绿蜜蜂,绿蜜蜂旧衣服回收,环保回收企业,再生资源回收',
            canonicalPath: '/p_aboutUs',
            schemas: [organizationSchema(), breadcrumbSchema([
                { name: '首页', path: '/' },
                { name: '关于我们', path: '/p_aboutUs' }
            ])]
        }
    },
    {
        path: '/p_login',
        name: 'p_login',
        component: () => import('@/views/pc/login'),
        meta: {
            showFooter: true,
            title: '用户登录 - 绿蜜蜂旧衣服回收',
            description: '绿蜜蜂旧衣服回收用户登录入口。',
            keywords: '绿蜜蜂登录,旧衣服回收登录',
            canonicalPath: '/p_login',
            robots: 'noindex,nofollow'
        }
    },

]
const routesM = [
    {
        path: '/',
        redirect: '/m_index'
    },
    {
        path: '/m_index',
        name: 'm_index',
        component: () => import('@/views/mobile/index'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_retrieve',
        name: 'm_retrieve',
        component: () => import('@/views/mobile/retrieve'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_address',
        name: 'm_address',
        component: () => import('@/views/mobile/address'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_addAddress',
        name: 'm_addAddress',
        component: () => import('@/views/mobile/addAddress'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_gift',
        name: 'm_gift',
        component: () => import('@/views/mobile/gift'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_mine',
        name: 'm_mine',
        component: () => import('@/views/mobile/mine'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_order',
        name: 'm_order',
        component: () => import('@/views/mobile/order'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_aboutUs',
        name: 'm_aboutUs',
        component: () => import('@/views/mobile/aboutUs'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_account',
        name: 'm_account',
        component: () => import('@/views/mobile/account'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_leaveWord',
        name: 'm_leaveWord',
        component: () => import('@/views/mobile/leaveWord'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_leaveWordReply',
        name: 'm_leaveWordReply',
        component: () => import('@/views/mobile/leaveWordReply'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_customer',
        name: 'm_customer',
        component: () => import('@/views/mobile/customer'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    },
    {
        path: '/m_success',
        name: 'm_success',
        component: () => import('@/views/mobile/success'),
        meta: {
            title: '旧衣服回收',
            showFooter: true,
            showHeader: true,
        }
    }
]

function isMobileRoute() {
    const hashPath = window.location.hash.replace(/^#/, '').split('?')[0]
    return hashPath.startsWith('/m_')
}

const useMobileRoute = isMobileRoute()
if (!useMobileRoute) {
    const hashRoute = window.location.hash.replace(/^#/, '')
    if (hashRoute.startsWith('/p_')) {
        window.history.replaceState(null, '', hashRoute)
    }
}
const routerHistory = useMobileRoute ? createWebHashHistory() : createWebHistory()

// 禁止浏览器在刷新/前进后退时自动恢复滚动位置，否则 scrollBehavior 会被覆盖
// if ('scrollRestoration' in history) {
//     history.scrollRestoration = 'manual'
// }

const router = createRouter({
    history: routerHistory,
    routes: useMobileRoute ? routesM : routes,
    scrollBehavior() {
        // // 从详情页返回时不恢复历史滚动，避免回到页脚区域
        // if (from.name === 'p_newDetail') {
        //     return { top: 0, left: 0 }
        // }
        // if (savedPosition) {
        //     return new Promise((resolve) => {
        //         nextTick(() => {
        //             resolve({ ...savedPosition, behavior: 'auto' })
        //         })
        //     })
        // }
        return { top: 0, left: 0 }
    }
})


router.afterEach((to) => {
    if (to.path.startsWith('/m_')) {
        window.document.title = to.meta.title || '旧衣服回收'
        return
    }

    applySeo(to.meta, to.path)
});

export default router;